var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcallLogsThreedotsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.6667C18.3682 18.6667 18.6667 18.3682 18.6667 18C18.6667 17.6318 18.3682 17.3333 18 17.3333C17.6318 17.3333 17.3333 17.6318 17.3333 18C17.3333 18.3682 17.6318 18.6667 18 18.6667Z",
    fill: "#464D48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 18.6667C23.0349 18.6667 23.3333 18.3682 23.3333 18C23.3333 17.6318 23.0349 17.3333 22.6667 17.3333C22.2985 17.3333 22 17.6318 22 18C22 18.3682 22.2985 18.6667 22.6667 18.6667Z",
    fill: "#464D48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.6667C13.7015 18.6667 14 18.3682 14 18C14 17.6318 13.7015 17.3333 13.3333 17.3333C12.9651 17.3333 12.6667 17.6318 12.6667 18C12.6667 18.3682 12.9651 18.6667 13.3333 18.6667Z",
    fill: "#464D48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.6667C18.3682 18.6667 18.6667 18.3682 18.6667 18C18.6667 17.6318 18.3682 17.3333 18 17.3333C17.6318 17.3333 17.3333 17.6318 17.3333 18C17.3333 18.3682 17.6318 18.6667 18 18.6667Z",
    stroke: "#464D48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 18.6667C23.0349 18.6667 23.3333 18.3682 23.3333 18C23.3333 17.6318 23.0349 17.3333 22.6667 17.3333C22.2985 17.3333 22 17.6318 22 18C22 18.3682 22.2985 18.6667 22.6667 18.6667Z",
    stroke: "#464D48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.6667C13.7015 18.6667 14 18.3682 14 18C14 17.6318 13.7015 17.3333 13.3333 17.3333C12.9651 17.3333 12.6667 17.6318 12.6667 18C12.6667 18.3682 12.9651 18.6667 13.3333 18.6667Z",
    stroke: "#464D48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#E1E6E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcallLogsThreedotsIcon);
export default __webpack_public_path__ + "static/media/gcall-logs-threedots-icon.49cab40918e40d1afff35b5332761c07.svg";
export { ForwardRef as ReactComponent };